import { FileEnums } from "models/enums";

const SupportAttachmentTypes = [FileEnums.ContentTypes.ApplicationPDF, FileEnums.ContentTypes.CSV];

// Excel is opened to auditors only: their working papers are spreadsheets, other users have no such need.
export const getSupportAttachmentTypes = (isRevisor: boolean): FileEnums.ContentTypes[] =>
  isRevisor ? [...SupportAttachmentTypes, FileEnums.ContentTypes.Xlsx] : SupportAttachmentTypes;
